module.exports = __webpack_public_path__ + "images/category_lp/hobby/store_images/3_8a07ea40d0898af8b3a44d5ed298d67b.png";